import { parse } from "date-fns";

import Role from "constants/role";
import { IAgent } from "store/entities/agents/interfaces";

type IAgentData = Omit<IAgent, "id" | "teamIds" | "roles"> & {
  ID: string;
  teamIDs: string[];
  roles: string[];
};

export default abstract class AgentSerializer {
  static deserializePermission(roles: string[]): Role {
    if (roles.includes("owner")) {
      return Role.Owner;
    }
    if (roles.includes("viewer")) {
      return Role.Viewer;
    }
    return Role.Normal;
  }

  static deserialize(data: IAgentData): IAgent {
    return {
      id: data.ID,
      // @ts-expect-error TS(2551): Property 'accountID' does not exist on type 'IAgen... Remove this comment to see the full error message
      accountId: data.accountID,
      name: data.name,
      signature: data.signature,
      email: data.email,
      jobTitle: data.jobTitle,
      teamIds: data.teamIDs,
      permission: AgentSerializer.deserializePermission(data.roles),
      avatar: data.avatar,
      flags: data.flags,
      settings: data.settings,
      autoassignmentTeamIDs: data.autoassignmentTeamIDs,
      autoassignment: data.autoassignment,
      status: data.status as "invited" | "active",
      createdAt: parse(data.createdAt),
      createdBy: data.createdBy,
      updatedAt: parse(data.updatedAt),
      updatedBy: data.updatedBy,
      emailVerified: data.emailVerified,
      webpushSubscriptions: data.webpushSubscriptions || [],
      organizationOwner: data.organizationOwner || false,
    };
  }

  static deserializeList(list: IAgentData[]): IAgent[] {
    return list.map(AgentSerializer.deserialize);
  }
}
